<mapfre-modal [modalOptions]="sendQuestionModal" [hideModal]="hideModal" (click)="unhideModal()"
  (closeModal)="resetHideModal($event)" (openModal)="saveAction()" (modalHide)="onHideModal()">
  <ng-container *ngIf="!hideMain">
    <div class="modal-body modal-border-radius" [ngClass]="{'acmic-padding color-9B9B9B': isAcmic}">
      <section>
      <div class="text-center">
        <div class="modal-icon-box-center">
            <img src={{modalIcon}} alt="ask question icon"/>
        </div>
          <div class="modal-ask-question-title">{{ 'ASK_QUESTION' | translate }}</div>
          <div class="modal-ask-question-sub-title">
            {{ 'BILLING_QUESTION_INFO_2' | translate }}
            <span>
              <a  
                class="contact-us-underline-link" 
                routerLink="/contact"
                (click)="onClickBack(true)"
              >{{'contact your agent'}}</a>.
            </span>
            <div *ngIf="!isAcmic">{{ 'REPLY_TWO_DAYS' | translate }}</div>
          </div>
      </div>
      <div class="aq-select-form">
        <form name="billingQuestionFormGroup" class="submit-question-form"
          [formGroup]="billingQuestionFormGroup" (ngSubmit)="sendQuestion()"
          [ngClass]="{'text-left ma-submit-question-form': !isAcmic}"
        >
          <ng-container *ngIf="policies.length>1">
            <div>
              <label for="select-policy" class="select-label mb-0" [ngClass]="{'modal-label':!isAcmic}">{{ "SELECT_POLICY" | translate }}</label>
                <ng-select 
                  [items]="policies"
                  bindLabel="typeNumTitle" 
                  [autofocus]="false" 
                  bindValue="policyNumber" 
                  [searchable]="false" 
                  [multiple]="false"
                  [clearable]="false" 
                  [markFirst]="false" 
                  placeholder="Select one" 
                  fixedPlaceholder="true"
                  [dropdownPosition]="'bottom'"
                  [formControlName]="'policies'"
                  (change)="onSelectionChange($event)"
                  (close)="onPolicyClose($event)"
                > 
                  <ng-template ng-option-tmp let-item="item" let-index="index">
                    <div 
                      class="custom-option"
                      [ngClass]="{'highlight-selected': index === 0 && hoveredIndex === null}"
                      (mouseenter)="hoveredIndex = index"
                    >
                      {{ item.typeNumTitle}} 
                    </div>
                  </ng-template>
                </ng-select>
            </div>
            <div
              *ngIf="!invalidPolicy"
              class="error-block form-control no-padding-left no-padding-top border border-0 rounded-0 h-auto">
              {{ 'Selection is required' | translate }}
            </div>
          </ng-container>

        <div class="mt-4">
          <label for="select-topic" class="select-label mb-0" [ngClass]="{'modal-label':!isAcmic}">{{ "Select topic*" | translate }}</label>
          <ng-select 
              [items]="topics"
              bindLabel="label" 
               bindValue="label"
              [autofocus]="false" 
              [searchable]="false" 
              [clearable]="false" 
              [markFirst]="false" 
              placeholder="Select one" 
              fixedPlaceholder="true"
              [dropdownPosition]="'bottom'"
              [formControlName]="'inquiryTopic'"
              (change)="onMessageTopicChange($event)"
              (close)="onTopicClose($event)"
              (open)="onTopicOpen($event)"
            > 
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div 
                  class="custom-option"
                  [ngClass]="{'highlight-selected': index === 0 && hoveredTopicIndex === null}"
                  (mouseenter)="hoveredTopicIndex = index"
                >
                  {{ item.label}}
                </div>
              </ng-template>
            </ng-select>
        </div>
        <div
          *ngIf="!invalidTopic"
          class="error-block form-control no-padding-left no-padding-top border border-0 rounded-0 h-auto">
          {{ 'Topic selection is required' | translate }}
        </div>

        <div [style.marginTop.px]="topicDropdownHeight">
          <label for="select-topic" class="select-label mb-0" [ngClass]="{'modal-label':!isAcmic}">{{ "ADD_YOUR_MESSAGE" | translate }}*</label>
          <textarea [formControlName]="'inquiryText'" [id]="'billing-text'" [name]="'billing-text'"
            placeholder="Type your question" class="billing-text" mdbInput
            [ngClass]="{'billing-select-errorr': !isAcmic && !invalidText,'modal-placeholder-text textarea-border':!isAcmic}"
            (blur)= "OnBlur()"></textarea>
        </div>
        <div *ngIf="!invalidText && isAcmic"
          class="error-block form-control no-padding-left no-padding-top border border-0 rounded-0 h-auto">
          {{ 'Entry of question is required' | translate }}
        </div>
        <div *ngIf="!invalidText && !isAcmic"
          class="error-block form-control no-padding-left no-padding-top border border-0 rounded-0 h-auto">
          {{ 'Required message' | translate }}
        </div>
         
        <ng-container *ngIf="isAcmic; else maButtonActions">
          <div class="top-space">
            <div class="row text-center">
              <div class="col">                  
                <mapfre-button 
                  [ngClass]="{'custom_loader':loader}" 
                  [additionalClasses]="'basic primary large-btn waves-effect'"
                  [inputType]="'submit'" [disabled]="!billingQuestionFormGroup.valid && !loader"
                  [translateValue]="'SUBMIT' | translate"
                ></mapfre-button>
              </div>                
            </div>
            <div class="row text-center mt-3">
              <div class="col">
                <mapfre-button [additionalClasses]="'link-button blue-link small acmic-btn-cancel'"
                  [iconClasses]="'align-middle'" (click)="onClickBack(true)">
                  {{ 'CANCEL' | translate }}
                </mapfre-button>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-template #maButtonActions>
          <div class="row text-right mt-4 billing-question-buttons">
            <div class="col show-btn-order">
              <mapfre-button [additionalClasses]="'ghost secondary small-btn modal-small-btn bn-cancel-btn'"
                [iconClasses]="'align-middle'" (click)="onClickBack(true)">
                {{ 'CANCEL' | translate }}
              </mapfre-button> 
              <mapfre-button [ngClass]="{'custom_loader':loader}" [additionalClasses]="'basic primary small-btn modal-small-btn bn-submitt-btn'"
                [inputType]="'submit'" [disabledValue]="billingQuestionFormGroup.controls.policies.valid && billingQuestionFormGroup.controls.inquiryTopic.valid && billingQuestionFormGroup.controls.inquiryText.valid && billingQuestionFormGroup.valid && !loader"
                [translateValue]="'SUBMIT' | translate"></mapfre-button>
            </div>
          </div>
        </ng-template>            
        </form>
        </div>
      </section>
    </div>
  </ng-container>

  <ng-container *ngIf="showSuccessModal">
    <app-billing-comment (hideModalOutput)="onClickBack($event)"></app-billing-comment>
  </ng-container>

  <ng-container *ngIf="showFailureModal">
    <app-billing-comment-unsuccessful (tryagain)="onTryAgain($event)"
      (hideModalOutput)="onClickBack($event)"></app-billing-comment-unsuccessful>
  </ng-container>
</mapfre-modal>